"use strict";import{Asset as e}from"./src/Asset.js";import{defineElement as s}from"@spectrum-web-components/base/src/define-element.js";s("sp-asset",e);
//# sourceMappingURL=sp-asset.js.map
